module.exports = __webpack_public_path__ + "img/banner-15.cb6ea69c.jpg";